import { CURRENCY } from "../../../../components/Constants";
import { ErrorMessage, Field } from "formik";
import {
  handleSalesInvoiceCalculation,
  n,
} from "../helpers/SalesInvoiceHelperFunction";

const TotalSection = ({
  values,
  setFieldValue,
}: {
  values: any;
  setFieldValue: any;
}) => {
  const updateValue = (key: string, val: any) => {
    const formatted = val && val > 0 ? +n(val).toFixed(3) : "";
    setFieldValue(key, formatted);
    return formatted;
  };

  return (
    <div className="card my-card">
      <div className="card-header my-card-header bg-lighter">
        <div>
          <h6 className="my-card-header-head">Total Details</h6>
        </div>
      </div>
      <div className="card-body my-card-body">
        <div className="row g-3 m-0">
          {/*Total Pricing Details */}

          <div className="col-12">
            <h6 className="my-card-header-head">• Total Pricing Details :</h6>
          </div>

          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_quantity"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total Quantity (MTS): <span className="text-danger">*</span>
            </label>
            <Field
              name="total_quantity"
              type="number"
              className="form-control"
              value={values.total_quantity}
              onChange={(e: any) => updateValue(e.target.name, e.target.value)}
            />
            <ErrorMessage
              name="total_quantity"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_amount"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total Amount ({CURRENCY.USD.SYMBOL}):{" "}
              <span className="text-danger">*</span>
            </label>
            <Field
              name="total_amount"
              type="number"
              className="form-control"
              value={values.total_amount || ""}
              onChange={(e: any) => {
                values.total_amount = updateValue(
                  e.target.name,
                  e.target.value || ""
                );

                handleSalesInvoiceCalculation(
                  "total_taxable_amount",
                  values,
                  setFieldValue
                );
                handleSalesInvoiceCalculation(
                  "commission_amount",
                  values,
                  setFieldValue
                );
              }}
            />
            <ErrorMessage
              name="total_amount"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div className="d-flex justify-content-between">
              <label
                htmlFor="exchange_rate"
                className="form-label"
                style={{ fontSize: "0.9375rem" }}
              >
                Exchange Rate ({CURRENCY.INR.SYMBOL}):
              </label>

              <div
                className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                onClick={() => {
                  window.open(
                    "https://foservices.icegate.gov.in/#/services/viewExchangeRate",
                    "_blank"
                  );
                }}
                title="Create clone sales contract"
                style={{ height: "24px" }}
              >
                <i className="ti ti-link"></i>
              </div>
            </div>

            <Field
              name="exchange_rate"
              type="number"
              className="form-control"
              value={values.exchange_rate || ""}
              onChange={(e: any) => {
                values.exchange_rate = updateValue(
                  e.target.name,
                  e.target.value
                );

                handleSalesInvoiceCalculation(
                  "total_taxable_amount",
                  values,
                  setFieldValue
                );
              }}
            />
            <ErrorMessage
              name="exchange_rate"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_taxable_amount_inr"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total Taxable Amount ({CURRENCY.INR.SYMBOL}):
            </label>
            <Field
              name="total_taxable_amount_inr"
              type="number"
              className="form-control"
              value={values.total_taxable_amount_inr || ""}
              onChange={(e: any) => {
                values.total_taxable_amount_inr = updateValue(
                  e.target.name,
                  e.target.value
                );

                handleSalesInvoiceCalculation(
                  "total_igst_amount",
                  values,
                  setFieldValue
                );
              }}
            />
            <ErrorMessage
              name="total_taxable_amount_inr"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="igst_percentage"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              IGST Percentage (%):
            </label>
            <Field
              name="igst_percentage"
              type="number"
              className="form-control"
              value={values.igst_percentage || ""}
              onChange={(e: any) => {
                values.igst_percentage = updateValue(
                  e.target.name,
                  e.target.value
                );

                handleSalesInvoiceCalculation(
                  "total_igst_amount",
                  values,
                  setFieldValue
                );
              }}
            />
            <ErrorMessage
              name="igst_percentage"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_igst_amount_inr"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total IGST Amount ({CURRENCY.INR.SYMBOL}):
            </label>
            <Field
              name="total_igst_amount_inr"
              type="number"
              className="form-control"
              value={values.total_igst_amount_inr || ""}
              onChange={(e: any) => {
                updateValue(e.target.name, e.target.value);
              }}
            />
            <ErrorMessage
              name="total_igst_amount_inr"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="commission_rate"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Commission Rate (%):
            </label>
            <Field
              name="commission_rate"
              type="number"
              className="form-control"
              value={values.commission_rate || ""}
              onChange={(e: any) => {
                values.commission_rate = updateValue(
                  e.target.name,
                  e.target.value || ""
                );

                handleSalesInvoiceCalculation(
                  "commission_amount",
                  values,
                  setFieldValue
                );
              }}
            />
            <ErrorMessage
              name="commission_rate"
              component="div"
              className="text-danger"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="commission_amount"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Commission Amount ({CURRENCY.USD.SYMBOL}):
            </label>
            <Field
              name="commission_amount"
              type="number"
              className="form-control"
              value={values.commission_amount || ""}
              onChange={(e: any) => {
                updateValue(e.target.name, e.target.value);
              }}
            />
            <ErrorMessage
              name="commission_amount"
              component="div"
              className="text-danger"
            />
          </div>

          {/* Total Packing Details */}
          <div className="col-12">
            <h6 className="my-card-header-head">• Total Packing Details :</h6>
          </div>

          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_no_of_bags"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total No Of Bags:
            </label>
            <Field
              name="total_no_of_bags"
              type="number"
              className="form-control"
              value={values.total_no_of_bags || ""}
              onChange={(e: any) => {
                updateValue(e.target.name, e.target.value);
              }}
            />
            <ErrorMessage
              name="total_no_of_bags"
              component="div"
              className="text-danger"
            />
          </div>

          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_net_weight"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total Net Weight (KGS):
            </label>
            <Field
              name="total_net_weight"
              type="number"
              className="form-control"
              value={values.total_net_weight || ""}
              onChange={(e: any) => {
                updateValue(e.target.name, e.target.value);
              }}
            />
            <ErrorMessage
              name="total_net_weight"
              component="div"
              className="text-danger"
            />
          </div>

          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label
              htmlFor="total_gross_weight"
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Total Gross Weight (KGS):
            </label>
            <Field
              name="total_gross_weight"
              type="number"
              className="form-control"
              value={values.total_gross_weight || ""}
              onChange={(e: any) => {
                updateValue(e.target.name, e.target.value);
              }}
            />
            <ErrorMessage
              name="total_gross_weight"
              component="div"
              className="text-danger"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalSection;
